import { Box, alpha } from '@mui/material';
import { FONT_MONO } from 'themes/tokens';

type Props = {
  revision: number;
  size?: 'small' | 'medium';
  showLabel?: boolean;
};

export const RevisionChip = ({ revision, size = 'medium', showLabel = true }: Props) => {
  const compact = size === 'small';
  return (
    <Box
      component="span"
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: '0.4em',
        fontFamily: FONT_MONO,
        fontSize: compact ? '0.72rem' : '0.8rem',
        lineHeight: 1,
        padding: compact ? '3px 8px' : '6px 12px',
        borderRadius: compact ? '7px' : '8px',
        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        color: theme.palette.info.main,
        whiteSpace: 'nowrap',
      })}
    >
      {showLabel && (
        <Box component="span" sx={{ fontWeight: 500, opacity: 0.7 }}>
          rev
        </Box>
      )}
      <Box component="span" sx={{ fontWeight: 700 }}>
        {revision}
      </Box>
    </Box>
  );
};

export default RevisionChip;
